var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2133 12.6769C15.2133 13.7616 16.7075 13.7616 16.7075 15.2577C16.7075 16.0829 16.0385 16.752 15.2133 16.752H3.25927C2.43395 16.752 1.76501 16.0829 1.76501 15.2577C1.76501 13.7641 3.25927 13.7641 3.25927 12.6769L3.25927 8.0853C3.25927 4.78431 5.94 2.10829 9.23627 2.10829C12.6471 2.10829 15.2133 4.78 15.2133 8.0853",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55426 20.1084H11.9229",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBell;